import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import Vuex from "vuex";
import VueParticles from "vue-particles";
import VModal from "vue-js-modal";
import vSelect from "vue-select";
import VueTableDynamic from "vue-table-dynamic-sum";

// import userService from "./services/user.service";
// import reportService from "./services/report.service";

import "vue-select/dist/vue-select.css";
import "bulma/css/bulma.min.css";
import "@creativebulma/bulma-tooltip/dist/bulma-tooltip.min.css";
import "./assets/styles/common.css";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUserSecret,
  faUser,
  faLock,
  faUserCircle,
  faEdit,
  faTrashAlt,
  faBan,
  faSave,
  faPlus,
  faFilePdf,
} from "@fortawesome/free-solid-svg-icons";

import { faOsi } from "@fortawesome/free-brands-svg-icons";

import Vuelidate from "vuelidate";

library.add(
  faUserSecret,
  faUser,
  faLock,
  faEdit,
  faUserCircle,
  faTrashAlt,
  faOsi,
  faBan,
  faSave,
  faPlus,
  faFilePdf,
);

Vue.config.productionTip = false;

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("vue-select", vSelect);

Vue.use(VueParticles);
Vue.use(Vuex);
Vue.use(VModal);
Vue.use(VueTableDynamic);
Vue.use(Vuelidate);

new Vue({
  router,
  store,
  render: (h) => h(App),
  mounted() {
    this.getStatuses();
    this.getDepartments();
    this.getRouteCards();
    this.getVehicles();
    this.getCompany();
    this.getUserId();
    this.getCheckpointNames();
    this.getCheckpointsOfInsideGates();
  },
  methods: {
    getStatuses() {
      const { dispatch } = this.$store;
      dispatch("general/setStatuses");
    },

    getRouteCards() {
      const { dispatch } = this.$store;
      dispatch("general/setRouteCards");
    },

    getVehicles() {
      const { dispatch } = this.$store;
      dispatch("general/setVehicles");
    },

    getCompany() {
      const { dispatch } = this.$store;
      dispatch("general/setCompany");
    },

    getUserId() {
      const { dispatch } = this.$store;
      dispatch("general/setUserId");
    },

    getDepartments() {
      console.log("STORE!");
      console.log(this.$store);
      const { dispatch } = this.$store;
      dispatch("general/setDepartmentData");
    },

    getCheckpointNames() {
      const { dispatch } = this.$store;
      dispatch("general/setCheckpointNames");
    },

    getCheckpointsOfInsideGates() {
      const { dispatch } = this.$store;
      dispatch("general/setCheckpointsOfInsideGates");
    },

    // arrangeEmployees(data) {
    //   let emps = [];

    //   data.forEach((element) => {
    //     element.employee.forEach((emp) => {
    //       emps.push({
    //         name: emp.firstName + " " + emp.lastName,
    //         id: emp.employeeId,
    //       });
    //     });

    //     this.$store.commit("general/emps", emps);
    //   });
    // },
  },
}).$mount("#app");
